import { SavedTemplate, VdpTemplate, VdpLayout, Unit } from '../types';

export const BLANK_CANVAS_TEMPLATE: VdpTemplate = {
  width: 250,
  height: 150,
  backgroundColor: '#ffffff',
  elements: []
};

export const STARTER_PRESETS: SavedTemplate[] = [
  {
    id: 'preset-shipping-label',
    name: 'Shipping & Product Label',
    description: 'Standard product barcode label with serial, price, and tracking QR code.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 250,
      height: 150,
      elements: [
        {
          id: 'p1',
          type: 'rectangle',
          x: 4,
          y: 4,
          width: 242,
          height: 142,
          borderWidth: 1.5,
          borderColor: '#2563eb',
          color: 'transparent'
        },
        {
          id: 'p2',
          type: 'text',
          x: 12,
          y: 12,
          text: 'EXPRESS SHIPPING LABEL',
          staticValue: 'EXPRESS SHIPPING LABEL',
          fontSize: 10,
          fontFamily: 'Helvetica',
          color: '#1e40af',
          isBold: true
        },
        {
          id: 'p3',
          type: 'text',
          x: 12,
          y: 28,
          columnName: 'Product_Name',
          staticValue: 'Premium Wireless Headphones',
          fontSize: 12,
          fontFamily: 'Helvetica',
          color: '#0f172a',
          isBold: true
        },
        {
          id: 'p4',
          type: 'currency',
          x: 12,
          y: 45,
          columnName: 'Price',
          staticValue: '149.99',
          prefix: 'USD $',
          fontSize: 11,
          fontFamily: 'Helvetica',
          color: '#166534',
          isBold: true
        },
        {
          id: 'p5',
          type: 'serial',
          x: 12,
          y: 62,
          columnName: 'Serial_No',
          staticValue: 'SN-2026-88401',
          prefix: 'S/N: ',
          fontSize: 9,
          fontFamily: 'Courier',
          color: '#475569'
        },
        {
          id: 'p6',
          type: 'barcode',
          x: 12,
          y: 80,
          width: 140,
          height: 40,
          columnName: 'Barcode',
          staticValue: '789012345678'
        },
        {
          id: 'p7',
          type: 'qr',
          x: 165,
          y: 55,
          width: 70,
          height: 70,
          columnName: 'Track_URL',
          staticValue: 'https://express.track/SN-88401'
        },
        {
          id: 'p8',
          type: 'date',
          x: 12,
          y: 128,
          columnName: 'Date',
          staticValue: '2026-08-26',
          prefix: 'MFG: ',
          fontSize: 8,
          fontFamily: 'Helvetica',
          color: '#64748b'
        }
      ]
    },
    layout: {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      rows: 4,
      cols: 2,
      gapX: 10,
      gapY: 10,
      marginX: 30,
      marginY: 30,
      showTrimMarks: true,
      exportMode: 'multi_up'
    }
  },
  {
    id: 'preset-asset-tag',
    name: 'Industrial Asset Tag',
    description: 'Compact equipment ID badge with DataMatrix/QR, serial, and die-cut boundary.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 190,
      height: 100,
      elements: [
        {
          id: 'a1',
          type: 'rectangle',
          x: 2,
          y: 2,
          width: 186,
          height: 96,
          isCutline: true,
          borderWidth: 1,
          borderColor: '#ec4899',
          color: 'transparent'
        },
        {
          id: 'a2',
          type: 'text',
          x: 10,
          y: 10,
          staticValue: 'PROPERTY OF TECH CORP',
          fontSize: 9,
          fontFamily: 'Helvetica',
          color: '#0f172a',
          isBold: true
        },
        {
          id: 'a3',
          type: 'text',
          x: 10,
          y: 26,
          columnName: 'Asset_Name',
          staticValue: 'MacBook Pro M3 Max',
          fontSize: 10,
          fontFamily: 'Helvetica',
          color: '#334155'
        },
        {
          id: 'a4',
          type: 'serial',
          x: 10,
          y: 44,
          columnName: 'Asset_ID',
          staticValue: 'AST-99401',
          prefix: 'ID: ',
          fontSize: 12,
          fontFamily: 'Courier',
          color: '#2563eb',
          isBold: true
        },
        {
          id: 'a5',
          type: 'qr',
          x: 125,
          y: 18,
          width: 55,
          height: 55,
          columnName: 'Asset_QR',
          staticValue: 'AST-99401-VERIFIED'
        },
        {
          id: 'a6',
          type: 'line',
          x: 10,
          y: 65,
          width: 110,
          height: 1,
          color: '#cbd5e1'
        },
        {
          id: 'a7',
          type: 'text',
          x: 10,
          y: 72,
          staticValue: 'DO NOT REMOVE',
          fontSize: 7,
          fontFamily: 'Helvetica',
          color: '#dc2626',
          isBold: true
        },
        {
          id: 'a8',
          type: 'currency',
          x: 80,
          y: 72,
          columnName: 'Asset_Value',
          staticValue: '1,299.00',
          prefix: 'Val: $',
          fontSize: 8,
          fontFamily: 'Helvetica',
          color: '#166534',
          isBold: true
        }
      ]
    },
    layout: {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      rows: 7,
      cols: 3,
      gapX: 8,
      gapY: 8,
      marginX: 20,
      marginY: 20,
      showTrimMarks: true,
      exportMode: 'multi_up'
    }
  },
  {
    id: 'preset-retail-price-tag',
    name: 'Retail Price & Promo Tag',
    description: 'Vibrant retail shelf tag with discount price, barcode, and promotional star.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 170,
      height: 120,
      elements: [
        {
          id: 'r1',
          type: 'rectangle',
          x: 0,
          y: 0,
          width: 170,
          height: 24,
          color: '#b91c1c'
        },
        {
          id: 'r2',
          type: 'text',
          x: 10,
          y: 6,
          staticValue: '★ SPECIAL OFFER',
          fontSize: 10,
          fontFamily: 'Helvetica',
          color: '#ffffff',
          isBold: true
        },
        {
          id: 'r3',
          type: 'text',
          x: 10,
          y: 32,
          columnName: 'Item_Title',
          staticValue: 'Organic Honey 500g',
          fontSize: 10,
          fontFamily: 'Helvetica',
          color: '#1e293b',
          isBold: true
        },
        {
          id: 'r4',
          type: 'currency',
          x: 10,
          y: 48,
          columnName: 'Sale_Price',
          staticValue: '12.50',
          prefix: '$',
          fontSize: 16,
          fontFamily: 'Helvetica',
          color: '#15803d',
          isBold: true
        },
        {
          id: 'r5',
          type: 'barcode',
          x: 10,
          y: 72,
          width: 150,
          height: 38,
          columnName: 'EAN_Code',
          staticValue: '890123456789'
        }
      ]
    },
    layout: {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      rows: 5,
      cols: 3,
      gapX: 10,
      gapY: 10,
      marginX: 25,
      marginY: 25,
      showTrimMarks: false,
      exportMode: 'multi_up'
    }
  },
  {
    id: 'preset-vip-badge',
    name: 'Event Pass & VIP Badge',
    description: 'Vertical ID pass with header ribbon, dynamic name, serial, and gate QR.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 180,
      height: 250,
      elements: [
        {
          id: 'v1',
          type: 'rectangle',
          x: 0,
          y: 0,
          width: 180,
          height: 45,
          color: '#312e81'
        },
        {
          id: 'v2',
          type: 'text',
          x: 12,
          y: 14,
          staticValue: 'SUMMIT 2026 • VIP',
          fontSize: 12,
          fontFamily: 'Helvetica',
          color: '#ffffff',
          isBold: true
        },
        {
          id: 'v3',
          type: 'text',
          x: 14,
          y: 60,
          columnName: 'Attendee_Name',
          staticValue: 'Dr. Sarah Jenkins',
          fontSize: 13,
          fontFamily: 'Helvetica',
          color: '#0f172a',
          isBold: true
        },
        {
          id: 'v4',
          type: 'text',
          x: 14,
          y: 80,
          columnName: 'Company',
          staticValue: 'Global Innovations Inc.',
          fontSize: 9,
          fontFamily: 'Helvetica',
          color: '#64748b'
        },
        {
          id: 'v5',
          type: 'serial',
          x: 14,
          y: 100,
          columnName: 'Pass_ID',
          staticValue: 'PASS-00842',
          prefix: 'ID: ',
          fontSize: 10,
          fontFamily: 'Courier',
          color: '#4f46e5',
          isBold: true
        },
        {
          id: 'v6',
          type: 'qr',
          x: 45,
          y: 125,
          width: 90,
          height: 90,
          columnName: 'Gate_QR',
          staticValue: 'GATE-PASS-00842-VALID'
        },
        {
          id: 'v7',
          type: 'date',
          x: 14,
          y: 228,
          columnName: 'Valid_Date',
          staticValue: '2026-10-15',
          prefix: 'VALID: ',
          fontSize: 8,
          fontFamily: 'Helvetica',
          color: '#94a3b8'
        }
      ]
    },
    layout: {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      rows: 3,
      cols: 3,
      gapX: 12,
      gapY: 12,
      marginX: 20,
      marginY: 20,
      showTrimMarks: true,
      exportMode: 'multi_up'
    }
  }  ,
  {
    id: 'preset-clothing-tag',
    name: 'Brand Clothing Tag',
    description: 'Tall hang tag for retail clothing with size, SKU barcode, and brand name.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 140,
      height: 250,
      elements: [
        { id: 'v1', type: 'rectangle', x: 0, y: 0, width: 140, height: 250, color: '#f8fafc' },
        { id: 'v2', type: 'text', x: 10, y: 20, staticValue: 'URBAN WEAR', fontSize: 16, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'v3', type: 'text', x: 10, y: 50, columnName: 'Size', staticValue: 'SIZE: M', fontSize: 14, fontFamily: 'Helvetica', color: '#333333' },
        { id: 'v4', type: 'barcode', x: 10, y: 80, width: 120, height: 40, columnName: 'SKU', staticValue: 'URB-8832-M' },
        { id: 'v5', type: 'text', x: 10, y: 130, columnName: 'Price', staticValue: '$49.99', fontSize: 18, fontFamily: 'Courier', color: '#b91c1c', isBold: true },
        { id: 'v6', type: 'text', x: 10, y: 220, staticValue: 'Machine wash cold.', fontSize: 8, fontFamily: 'Helvetica', color: '#64748b' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'landscape', rows: 2, cols: 5, gapX: 10, gapY: 10, marginX: 20, marginY: 20, showTrimMarks: true, exportMode: 'multi_up' }
  },
  {
    id: 'preset-coffee-label',
    name: 'Coffee Roast Label',
    description: 'Square label for coffee bags with roast type, origin, and date.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 200,
      height: 200,
      elements: [
        { id: 'c1', type: 'rectangle', x: 0, y: 0, width: 200, height: 200, color: '#27272a' },
        { id: 'c2', type: 'text', x: 10, y: 20, staticValue: 'ARTISAN ROASTERS', fontSize: 14, fontFamily: 'Courier', color: '#facc15', isBold: true },
        { id: 'c3', type: 'text', x: 10, y: 60, columnName: 'Origin', staticValue: 'ETHIOPIA YIRGACHEFFE', fontSize: 12, fontFamily: 'Helvetica', color: '#ffffff' },
        { id: 'c4', type: 'text', x: 10, y: 85, columnName: 'Roast_Level', staticValue: 'Light Roast', fontSize: 10, fontFamily: 'Helvetica', color: '#a1a1aa' },
        { id: 'c5', type: 'text', x: 10, y: 110, columnName: 'Notes', staticValue: 'Floral, Citrus, Jasmine', fontSize: 9, fontFamily: 'Helvetica', color: '#d4d4d8' },
        { id: 'c6', type: 'date', x: 10, y: 170, columnName: 'Roast_Date', staticValue: '2026-09-10', prefix: 'ROASTED: ', fontSize: 9, fontFamily: 'Courier', color: '#ffffff' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 3, cols: 2, gapX: 15, gapY: 15, marginX: 25, marginY: 25, showTrimMarks: false, exportMode: 'multi_up' }
  },
  {
    id: 'preset-pharmacy-label',
    name: 'Pharmacy Prescription',
    description: 'Medical label with patient name, dosage, and warning barcode.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 280,
      height: 120,
      elements: [
        { id: 'p1', type: 'rectangle', x: 0, y: 0, width: 280, height: 120, color: '#ffffff' },
        { id: 'p2', type: 'rectangle', x: 0, y: 0, width: 280, height: 20, color: '#dc2626' },
        { id: 'p3', type: 'text', x: 5, y: 5, staticValue: 'RX ONLY - KEEP AWAY FROM CHILDREN', fontSize: 9, fontFamily: 'Helvetica', color: '#ffffff', isBold: true },
        { id: 'p4', type: 'text', x: 10, y: 30, columnName: 'Patient_Name', staticValue: 'John Doe', fontSize: 14, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'p5', type: 'text', x: 10, y: 55, columnName: 'Medication', staticValue: 'Amoxicillin 500mg', fontSize: 12, fontFamily: 'Helvetica', color: '#333333' },
        { id: 'p6', type: 'text', x: 10, y: 75, columnName: 'Instructions', staticValue: 'Take 1 capsule by mouth 3 times daily', fontSize: 9, fontFamily: 'Helvetica', color: '#000000' },
        { id: 'p7', type: 'barcode', x: 170, y: 70, width: 100, height: 35, columnName: 'Rx_Number', staticValue: 'RX987654321' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 6, cols: 2, gapX: 10, gapY: 10, marginX: 15, marginY: 15, showTrimMarks: true, exportMode: 'multi_up' }
  },
  {
    id: 'preset-inventory-bin',
    name: 'Warehouse Bin Label',
    description: 'High visibility bin location label with large barcode and location ID.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 300,
      height: 100,
      elements: [
        { id: 'i1', type: 'rectangle', x: 0, y: 0, width: 300, height: 100, color: '#fde047' },
        { id: 'i2', type: 'text', x: 10, y: 15, columnName: 'Zone', staticValue: 'ZONE A - AISLE 4', fontSize: 12, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'i3', type: 'text', x: 10, y: 35, columnName: 'Bin_ID', staticValue: 'BIN-4492-X', fontSize: 24, fontFamily: 'Courier', color: '#000000', isBold: true },
        { id: 'i4', type: 'barcode', x: 140, y: 15, width: 150, height: 60, columnName: 'Bin_Barcode', staticValue: 'BIN4492X' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 7, cols: 1, gapX: 0, gapY: 15, marginX: 40, marginY: 30, showTrimMarks: false, exportMode: 'multi_up' }
  },
  {
    id: 'preset-nutrition-facts',
    name: 'Nutrition Facts Panel',
    description: 'Standard nutrition facts label for food packaging.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 180,
      height: 260,
      elements: [
        { id: 'n1', type: 'rectangle', x: 0, y: 0, width: 180, height: 260, color: '#ffffff' },
        { id: 'n2', type: 'rectangle', x: 5, y: 5, width: 170, height: 250, color: '#ffffff' },
        { id: 'n3', type: 'text', x: 10, y: 15, staticValue: 'Nutrition Facts', fontSize: 18, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'n4', type: 'rectangle', x: 10, y: 40, width: 160, height: 4, color: '#000000' },
        { id: 'n5', type: 'text', x: 10, y: 55, staticValue: 'Serving Size', fontSize: 10, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'n6', type: 'text', x: 90, y: 55, columnName: 'Serving_Size', staticValue: '1 cup (240ml)', fontSize: 10, fontFamily: 'Helvetica', color: '#000000' },
        { id: 'n7', type: 'rectangle', x: 10, y: 75, width: 160, height: 8, color: '#000000' },
        { id: 'n8', type: 'text', x: 10, y: 95, staticValue: 'Calories', fontSize: 16, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'n9', type: 'text', x: 120, y: 95, columnName: 'Calories', staticValue: '110', fontSize: 16, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'n10', type: 'rectangle', x: 10, y: 110, width: 160, height: 2, color: '#000000' },
        { id: 'n11', type: 'text', x: 10, y: 125, staticValue: 'Total Fat', fontSize: 10, fontFamily: 'Helvetica', color: '#000000', isBold: true },
        { id: 'n12', type: 'text', x: 70, y: 125, columnName: 'Fat', staticValue: '2.5g', fontSize: 10, fontFamily: 'Helvetica', color: '#000000' },
        { id: 'n13', type: 'barcode', x: 30, y: 200, width: 120, height: 40, columnName: 'Product_UPC', staticValue: '123456789012' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 3, cols: 3, gapX: 10, gapY: 10, marginX: 15, marginY: 15, showTrimMarks: true, exportMode: 'multi_up' }
  },
  {
    id: 'preset-visitor-pass',
    name: 'Visitor Parking Pass',
    description: 'Landscape dashboard parking permit with valid dates and QR.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 250,
      height: 150,
      elements: [
        { id: 'v1', type: 'rectangle', x: 0, y: 0, width: 250, height: 150, color: '#eef2ff' },
        { id: 'v2', type: 'rectangle', x: 0, y: 0, width: 250, height: 35, color: '#4338ca' },
        { id: 'v3', type: 'text', x: 15, y: 12, staticValue: 'VISITOR PARKING PERMIT', fontSize: 14, fontFamily: 'Helvetica', color: '#ffffff', isBold: true },
        { id: 'v4', type: 'text', x: 15, y: 55, columnName: 'Visitor_Name', staticValue: 'Emily R. Stone', fontSize: 16, fontFamily: 'Helvetica', color: '#111827', isBold: true },
        { id: 'v5', type: 'text', x: 15, y: 80, staticValue: 'Valid Until:', fontSize: 10, fontFamily: 'Helvetica', color: '#6b7280' },
        { id: 'v6', type: 'date', x: 15, y: 95, columnName: 'Valid_Until', staticValue: 'Oct 31, 2026', fontSize: 14, fontFamily: 'Courier', color: '#dc2626', isBold: true },
        { id: 'v7', type: 'qr', x: 165, y: 60, width: 70, height: 70, columnName: 'Permit_Code', staticValue: 'PRMT-X987' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 5, cols: 2, gapX: 15, gapY: 15, marginX: 20, marginY: 20, showTrimMarks: false, exportMode: 'multi_up' }
  },
  {
    id: 'preset-logistics-pdf417',
    name: 'Logistics & Boarding Pass (PDF417)',
    description: 'Industrial parcel & transit boarding pass with high-density PDF417 stacked 2D barcode.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 280,
      height: 130,
      backgroundColor: '#ffffff',
      elements: [
        { id: 'lp-bg', type: 'rectangle', x: 4, y: 4, width: 272, height: 122, borderWidth: 1.5, borderColor: '#0284c7', color: 'transparent', borderRadius: 4 },
        { id: 'lp-hdr', type: 'rectangle', x: 4, y: 4, width: 272, height: 26, color: '#0284c7' },
        { id: 'lp-t1', type: 'text', x: 12, y: 8, staticValue: 'EXPRESS AIRWAYS & LOGISTICS', fontSize: 10, fontFamily: 'Helvetica', color: '#ffffff', isBold: true },
        { id: 'lp-t2', type: 'text', x: 210, y: 8, staticValue: 'PRIORITY 1', fontSize: 9, fontFamily: 'Courier', color: '#e0f2fe', isBold: true },
        { id: 'lp-pname', type: 'text', x: 14, y: 35, columnName: 'Recipient_Name', staticValue: 'Marcus Vance / Cargo Dept', fontSize: 12, fontFamily: 'Helvetica', color: '#0f172a', isBold: true },
        { id: 'lp-trk', type: 'text', x: 14, y: 52, columnName: 'Tracking_Code', staticValue: 'WAYBILL #9948-AX-01', fontSize: 9, fontFamily: 'Courier', color: '#64748b' },
        { id: 'lp-pdf417', type: 'pdf417', x: 14, y: 68, width: 175, height: 50, columnName: 'Barcode_Payload', staticValue: 'PDF417-AWB9948AX01-DEST-ORD-PKG3' },
        { id: 'lp-dest-box', type: 'rectangle', x: 200, y: 68, width: 68, height: 50, color: '#f0fdf4', borderWidth: 1, borderColor: '#16a34a', borderRadius: 4 },
        { id: 'lp-dest-lbl', type: 'text', x: 205, y: 73, staticValue: 'DEST AIRPORT', fontSize: 7, fontFamily: 'Helvetica', color: '#166534' },
        { id: 'lp-dest-code', type: 'text', x: 207, y: 86, columnName: 'Destination_Port', staticValue: 'ORD', fontSize: 20, fontFamily: 'Helvetica', color: '#14532d', isBold: true }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 4, cols: 2, gapX: 12, gapY: 12, marginX: 15, marginY: 15, showTrimMarks: false, exportMode: 'multi_up' }
  },
  {
    id: 'preset-pharma-aztec',
    name: 'Pharma & High-Speed Transit (Aztec Code)',
    description: 'Precision healthcare batch & security transit ticket with high-tolerance Aztec 2D matrix.',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isPreset: true,
    appUnit: 'pt',
    template: {
      width: 240,
      height: 140,
      backgroundColor: '#ffffff',
      elements: [
        { id: 'pa-bg', type: 'rectangle', x: 3, y: 3, width: 234, height: 134, borderWidth: 1.5, borderColor: '#7c3aed', color: 'transparent', borderRadius: 6 },
        { id: 'pa-top', type: 'rectangle', x: 3, y: 3, width: 234, height: 28, color: '#7c3aed' },
        { id: 'pa-title', type: 'text', x: 12, y: 9, staticValue: 'PHARMA-VUE RX VERIFICATION', fontSize: 10, fontFamily: 'Helvetica', color: '#ffffff', isBold: true },
        { id: 'pa-drug', type: 'text', x: 12, y: 38, columnName: 'Product_Name', staticValue: 'Amoxicillin Trihydrate 500mg', fontSize: 11, fontFamily: 'Helvetica', color: '#0f172a', isBold: true },
        { id: 'pa-batch', type: 'text', x: 12, y: 56, columnName: 'Batch_No', staticValue: 'BATCH: B26-9041A', fontSize: 8.5, fontFamily: 'Courier', color: '#475569' },
        { id: 'pa-mfg', type: 'date', x: 12, y: 72, columnName: 'Exp_Date', staticValue: '2028-10-15', prefix: 'EXP: ', fontSize: 8.5, fontFamily: 'Courier', color: '#dc2626', isBold: true },
        { id: 'pa-rx', type: 'serial', x: 12, y: 88, columnName: 'Serial_No', staticValue: 'RX-99410', prefix: 'DISPENSE ID: ', fontSize: 8, fontFamily: 'Courier', color: '#6b7280' },
        { id: 'pa-aztec', type: 'aztec', x: 155, y: 38, width: 75, height: 75, columnName: 'Security_Code', staticValue: 'AZTEC-RX99410-B26-EXP2028' },
        { id: 'pa-footer', type: 'text', x: 12, y: 122, staticValue: 'ISO 15434 / GS1 HEALTHCARE STANDARDS COMPLIANT', fontSize: 6.5, fontFamily: 'Helvetica', color: '#94a3b8' }
      ]
    },
    layout: { pageSize: 'A4', pageOrientation: 'portrait', rows: 4, cols: 2, gapX: 12, gapY: 12, marginX: 20, marginY: 20, showTrimMarks: false, exportMode: 'multi_up' }
  }
];

const LOCAL_STORAGE_KEY = 'vdp_user_saved_templates_v2';
const DB_NAME = 'VdpTemplatesDB';
const DB_VERSION = 1;
const STORE_NAME = 'user_templates';

const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.indexedDB) {
      reject(new Error('IndexedDB not available'));
      return;
    }
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (e: any) => {
      const db = e.target.result as IDBDatabase;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    };
  });
};

export const getSavedTemplates = async (): Promise<SavedTemplate[]> => {
  let userTemplates: SavedTemplate[] = [];

  // 1. Try reading from IndexedDB
  try {
    const dbInst = await openDB();
    const tx = dbInst.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const request = store.getAll();
    const idbTemplates = await new Promise<SavedTemplate[]>((resolve, reject) => {
      request.onsuccess = () => resolve(request.result || []);
      request.onerror = () => reject(request.error);
    });
    idbTemplates.forEach(t => {
      if (t && t.id && !userTemplates.some(ut => ut.id === t.id)) {
        userTemplates.push(t);
      }
    });
  } catch (idbErr) {
    // IndexedDB fallback
  }

  // 2. Fallback or merge with localStorage
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (raw) {
      const lsTemplates: SavedTemplate[] = JSON.parse(raw);
      if (Array.isArray(lsTemplates)) {
        const map = new Map<string, SavedTemplate>();
        userTemplates.forEach(t => t && t.id && map.set(t.id, t));
        lsTemplates.forEach(t => t && t.id && !map.has(t.id) && map.set(t.id, t));
        userTemplates = Array.from(map.values());
      }
    }
  } catch (lsErr) {
    console.error('Failed to load local templates from localStorage:', lsErr);
  }

  const map = new Map<string, SavedTemplate>();
  userTemplates.forEach((t) => {
    if (t && t.id) map.set(t.id, t);
  });

  STARTER_PRESETS.forEach((preset) => {
    if (preset && preset.id && !map.has(preset.id)) {
      map.set(preset.id, preset);
    }
  });

  const uniqueTemplates = Array.from(map.values());
  uniqueTemplates.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

  return uniqueTemplates;
};

export const saveUserTemplate = async (
  name: string,
  template: VdpTemplate,
  layout: VdpLayout,
  appUnit: Unit,
  description?: string
): Promise<SavedTemplate> => {
  const newId = 'tpl_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  const now = new Date().toISOString();

  const newTemplate: SavedTemplate = {
    id: newId,
    name: name.trim() || 'Untitled Template',
    description: description || 'Saved template',
    createdAt: now,
    updatedAt: now,
    appUnit,
    template,
    layout,
    isPreset: false
  };

  // 1. Save to local IndexedDB
  try {
    const dbInst = await openDB();
    const tx = dbInst.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.put(newTemplate);
  } catch (idbErr) {}

  // 2. Save to LocalStorage with quota protection
  try {
    const existingRaw = localStorage.getItem(LOCAL_STORAGE_KEY);
    const userSaved: SavedTemplate[] = existingRaw ? JSON.parse(existingRaw) : [];
    const updated = [newTemplate, ...userSaved.filter(t => t.id !== newTemplate.id)].slice(0, 20);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  } catch (lsErr) {}

  return newTemplate;
};

export const deleteUserTemplate = async (id: string): Promise<boolean> => {
  let success = false;

  // 1. Delete from IndexedDB
  try {
    const dbInst = await openDB();
    const tx = dbInst.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await new Promise<void>((resolve, reject) => {
      const req = store.delete(id);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
    success = true;
  } catch (idbErr) {}

  // 2. Delete from LocalStorage
  try {
    const existingRaw = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (existingRaw) {
      let userSaved: SavedTemplate[] = JSON.parse(existingRaw);
      userSaved = userSaved.filter((t) => t.id !== id);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(userSaved));
      success = true;
    }
  } catch (lsErr) {}

  return success;
};

export const exportTemplateAsJSON = (savedTpl: SavedTemplate) => {
  const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(savedTpl, null, 2));
  const downloadAnchor = document.createElement('a');
  downloadAnchor.setAttribute("href", dataStr);
  const filename = `${savedTpl.name.toLowerCase().replace(/[^a-z0-9]/g, '_')}_template.json`;
  downloadAnchor.setAttribute("download", filename);
  document.body.appendChild(downloadAnchor);
  downloadAnchor.click();
  downloadAnchor.remove();
};
